import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class CustomersFiles extends CommonCRUD {}

export default CustomersFiles;
